// =====================================================================
// ThemeToggle, Sun <-> Moon switch.
//
// Icon-only circular button. Two size variants:
//   default   - 36px circle, used in the landing desktop nav
//   compact   - 32px circle, used in mobile nav, AppShell, legal,
//               and every authenticated portal top bar
//
// The previous incarnation included a labelled "Dark mode" /
// "Light mode" form and a label-only "text" form. Both are gone:
// the moon/sun icon carries the affordance, the aria-label and
// title surface the action for screen readers and hover tooltips,
// and dropping the text lets the nav breathe on small viewports
// without needing a media-query-driven label-collapse hack.
// =====================================================================

import { Moon, Sun } from "lucide-react";
import { useTheme } from "../context/ThemeContext.jsx";

export default function ThemeToggle({ variant = "default", className = "" }) {
  const { isDark, toggle } = useTheme();
  const aria = `Switch to ${isDark ? "light" : "dark"} mode`;
  const variantClass =
    variant === "compact" ? "theme-toggle--compact" : "";

  return (
    <button
      type="button"
      className={`theme-toggle ${variantClass} ${className}`.trim()}
      onClick={toggle}
      aria-label={aria}
      title={aria}
    >
      {isDark ? <Sun size={14} /> : <Moon size={14} />}
    </button>
  );
}
